import { render, staticRenderFns } from "./ValueUnitDetailView.vue?vue&type=template&id=f35ffadc&scoped=true"
import script from "./ValueUnitDetailView.vue?vue&type=script&lang=js"
export * from "./ValueUnitDetailView.vue?vue&type=script&lang=js"
import style0 from "./ValueUnitDetailView.vue?vue&type=style&index=0&id=f35ffadc&prod&lang=css"
import style1 from "./ValueUnitDetailView.vue?vue&type=style&index=1&id=f35ffadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35ffadc",
  null
  
)

export default component.exports